import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../variants";
import workImg1 from "../assets/portfolio1.png";
import workImg2 from "../assets/portfolio2.png";
import workImg3 from "../assets/portfolio3.png";

const Work = () => {
  return (
    <section id="work" className="section">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-x-10">
          <motion.div
            variants={fadeIn("right", "0.3")}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0"
          >
            <div>
              <h2 className="h2 text-accent leading-tight">
                My recent <br /> projects
              </h2>
              <p className="max-w-sm mb-16">
                These is some of my recent projects. To see all, of them click on
                the button below.
              </p>
              <a
                href="https://github.com/GabrielMorettii"
                target="_blank"
                rel="noreferrer"
              >
                <button className="btn btn-sm">Show all</button>
              </a>
            </div>

            <a
              href="https://coffee-delivering-gabrielmorettii.vercel.app/"
              target="_blank"
              rel="noreferrer"
              className="h-full"
            >
              <div className="group relative overflow-hidden border-2 border-white/30 rounded-xl h-full">
                <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                <img
                  className="group-hover:scale-125 transition-all duration-500 h-full"
                  src={workImg1}
                  alt="work img 1"
                />
                <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                  <span className="text-gradient">Web App</span>
                </div>
                <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                  <span className="text-3xl text-white">Node Streaming</span>
                </div>
              </div>
            </a>
          </motion.div>
          <motion.div
            variants={fadeIn("left", "0.2")}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 flex flex-col gap-y-10"
          >
            <a
              href="https://ignite-shop-gabrielmorettii.vercel.app"
              target="_blank"
              rel="noreferrer"
            >
              <div className="group relative overflow-hidden border-2 border-white/30 rounded-xl">
                <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                <img
                  className="group-hover:scale-125 transition-all duration-500"
                  src={workImg2}
                  alt="work img 1"
                />
                <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                  <span className="text-gradient">Command-line Tool</span>
                </div>
                <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                  <span className="text-3xl text-white">Instagram Scraper</span>
                </div>
              </div>
            </a>

            <a
              href="https://book-wise-gabrielmorettii.vercel.app"
              target="_blank"
              rel="noreferrer"
            >
              <div className="group relative overflow-hidden border-2 border-white/30 rounded-xl">
                <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                <img
                  className="group-hover:scale-125 transition-all duration-500"
                  src={workImg3}
                  alt="work img 1"
                />
                <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                  <span className="text-gradient"> Web App </span>
                </div>
                <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                  <span className="text-3xl text-white">Book Wise</span>
                </div>
              </div>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Work;
